import React from 'react';
import { WaitlistTopNav } from '../components/WaitlistTopNav';
import { Footer } from '../components/Footer';

export const TermsPage: React.FC = () => (
  <div className="min-h-screen bg-white">
    <WaitlistTopNav />
    <div className="max-w-2xl mx-auto p-8">
      <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>
      <p className="mb-4">Last updated: June 2024</p>
      <h2 className="text-xl font-semibold mt-6 mb-2">1. Acceptance of Terms</h2>
      <p>
        By accessing or using SimpleTracker, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree, you are prohibited from using or accessing this site.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">2. Use License</h2>
      <p>
        Permission is granted to temporarily download one copy of the materials for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">3. User Accounts</h2>
      <p>
        You are responsible for maintaining the security of your account and password. You agree to provide accurate and complete information.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">4. Disclaimer</h2>
      <p>
        The materials on SimpleTracker are provided 'as is'. SimpleTracker makes no warranties, expressed or implied, and hereby disclaims all other warranties.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">5. Limitations</h2>
      <p>
        In no event shall SimpleTracker or its suppliers be liable for any damages arising out of the use or inability to use the materials on SimpleTracker.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">6. Modifications</h2>
      <p>
        SimpleTracker may revise these terms of service at any time without notice. By using this site you are agreeing to be bound by the then current version.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">7. Governing Law</h2>
      <p>
        These terms and conditions are governed by and construed in accordance with the laws of your jurisdiction.
      </p>
    </div>
    <Footer />
  </div>
); 